/**
 * Issue #221 / #222 / #224 — 分区页签的纯状态 helper（与 SegmentedTabs 组件配套）。
 *
 * 把「校验 / 收敛当前激活的 tab key」抽成纯函数，便于单测，组件只持有 string state。
 */

/** 收敛任意输入到合法 tab key：命中白名单则保留，否则回退到第一个（默认）tab。 */
export function resolveActiveTab<K extends string>(
  candidate: string | null | undefined,
  validKeys: readonly K[],
): K {
  if (validKeys.length === 0) {
    throw new Error('resolveActiveTab: validKeys must be non-empty');
  }
  if (candidate != null && (validKeys as readonly string[]).includes(candidate)) {
    return candidate as K;
  }
  return validKeys[0];
}
